import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useVsgSdk } from 'alelo-logic/contexts/vsgSdkContext'
import qs from 'qs'

import { setAuthentication } from 'alelo-logic/actions'

import { Container } from './styles'
const { pjURL } = require('../../../alelo-logic/config.json')

const Login = ({ onSuccess, onFirstAccess, onForgotPassword }) => {
  document.title = 'Minha Veloe | Login'
  const vsgSdk = useVsgSdk()

  useEffect(() => {
    const loginComponent = vsgSdk.renderizarAutenticacao({
      banners: [
        {
          title: '',
          description: '',
          image: '/images/login.jpg'
        }
      ],
      loginScreenConfig: {
        title: 'Pode entrar que a casa é sua ;)',
        subtitle: '',
        credentialType: 'cpf',
        callToActionLink: {
          description: 'Pessoa Jurídica? Clique aqui',
          url: pjURL
        }
      },
      requestLocationPermission: false
    })

    loginComponent.on('esqueci-minha-senha', onForgotPassword)

    loginComponent.on('primeiro-acesso', onFirstAccess)

    loginComponent.on('sucesso', onSuccess)
  }, [vsgSdk])

  return <Container id="vsg-autenticacao" data-testid="vsg-autenticacao" />
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSuccess: ({ accessToken, refreshToken, expiresIn, tokenType, requerMFA, recurso, login }) => {
    const loginData = {
      access_token: accessToken,
      token_type: tokenType,
      expires_in: expiresIn,
      refresh_token: refreshToken,
      login
    }

    dispatch(setAuthentication(loginData))
      .then(() => {
        window.dataLayer.push({
          event: 'event',
          eventCategory: 'veloe:login',
          eventAction: 'login:tentativa',
          eventLabel: 'continuar:sucesso'
        })

        if (requerMFA) {
          ownProps.history.push(
            `/conta/mfa?${qs.stringify({
              resource: recurso,
              previousUrl: '/conta/login',
              nextUrl: '/conta/termos',
              token: accessToken
            })}`
          )
          return
        }

        ownProps.history.push('/conta/termos')
      })
      .catch(() => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'login',
          eventCategory: 'veloe:login',
          eventAction: 'login:tentativa',
          eventLabel: 'continuar:erro'
        })
      })
  },
  onFirstAccess: () => {
    window.dataLayer.push({
      event: 'event',
      eventAction: 'clique:primeira-visita',
      eventCategory: 'veloe:login',
      eventLabel: 'login'
    })
    ownProps.history.push('/conta/primeiro-acesso')
  },
  onForgotPassword: () => {
    window.dataLayer.push({
      event: 'event',
      eventAction: 'esqueci-senha:tentativa',
      eventCategory: 'veloe:login',
      eventLabel: 'clique:login'
    })
    ownProps.history.push('/conta/esqueci-a-senha')
  }
})

export default connect(null, mapDispatchToProps)(Login)
